import globals from "@/utils/globals"
import { cookie } from "@/utils/cookie"
import { getCurrentPageUrl } from "@/utils/location"

const trackingConsent = () => {
  if (["test", "development"].includes(globals.env)) {
    return true
  }

  const consentCookie = cookie("CookieConsent")

  return consentCookie && consentCookie.indexOf("statistics:true") >= 0
}

const getUrlParams = () => {
  const now = new Date()
  const actionName = document.querySelector("title").innerText

  /* eslint-disable camelcase */
  const urlParams = new URLSearchParams({
    idsite: 1,
    rec: 1,
    r: String(Math.random()).slice(2, 8),
    pv_id: generateUniqueId(),
    url: getCurrentPageUrl(),
    action_name: actionName,
    bk_u_g: 0,
    bk_u_s: globals.segment,
    bk_c_n: globals.fingerprint,
    h: now.getHours(),
    m: now.getMinutes(),
    s: now.getSeconds(),
    _idn: 0,
    res: getScreenResolution()
  })

  /* eslint-enable camelcase */
  if (document.referrer) {
    urlParams.set("urlref", document.referrer)
  }

  return urlParams
}

const getScreenResolution = () => {
  const height = window.screen.height
  const width = window.screen.width

  return `${width}x${height}`
}

const generateUniqueId = () => {
  let id = ""
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"

  for (let i = 0; i < 6; i++) {
    id += chars.charAt(Math.floor(Math.random() * chars.length))
  }

  return id
}

const makePiwikRequest = ({ category, action, name, customVariables } = {}) => {
  if (!trackingConsent()) {
    return
  }

  const params = getUrlParams()

  if (category) {
    params.set("e_c", category)
  }

  if (action) {
    params.set("e_a", action)
  }

  if (name) {
    params.set("e_n", name)
  }

  /*--
  Add custom variables to tracking with simple property / value pairs
  It will be translated to the correct format
  from: customVariables: { var: "foo" }
  to: customVariables: { "1": ["var", "foo"] }
  */
  if (customVariables) {
    let index = 1
    const vars = Object.keys(customVariables).reduce((a, v) => {
      a[index] = [v, customVariables[v]]
      index++
      return a
    }, {})
    params.set("cvar", JSON.stringify(vars))
  }

  const image = new Image(1, 1)
  image.src = `${globals.piwikUrl}?${params}`
}

window.onerror = function (msg, url, lineNumber, columnNumber) {
  const customVariables = {
    ErrorLog: msg.toString().substring(0, 2000)
  }

  if (url) {
    customVariables.URL = url.toString()
  }

  if (lineNumber) {
    customVariables.LineNumber = lineNumber.toString()
  }

  if (columnNumber) {
    customVariables.ColumnNumber = columnNumber.toString()
  }

  const eventAttributes = {
    category: "body-20181129-js_error",
    action: "payment_js_error",
    customVariables
  }

  makePiwikRequest(eventAttributes)
}

export const trackEvent = (eventAttributes) => {
  makePiwikRequest(eventAttributes)
}

export const trackPageview = () => {
  makePiwikRequest()
}
